import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
import { useHistory } from "react-router-dom";
const Signup = () =>{
    const history = useHistory()
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <HeaderSection 
               title="Sign Up" 
               smallTitle="Join " 
               usmallTitle=" Smart Shopper."
               />
               <section id="section_shop">
                   <div id="order_id_div">
                     <label id="order_id_labal">Your Name</label>
                     <input type="text"  id="order_id_div_input"/>   
                     <label id="order_id_labal">Email</label>
                     <input type="text"  id="order_id_div_input"/>
                     <label id="order_id_labal">Passowrd</label>
                     <input type="password"  id="order_id_div_input"/>
                     <button id="order_id_button_login">Signup</button>
                     <div className="row col-12 noMP">
                            <div className="col noMP left_side" 
                            onClick={(()=>{
                                history.push('/login')
                            })}
                            id="login_words">
                                Already have an account?  <u>Login</u> 
                            </div>
                            <div className="col noMP right_side" id="login_words">
                                    Forget Password?
                            </div>
                     </div>
                   </div>
               </section>
            <Footer />
        </div>
    )
}
export default Signup;
